var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgBook(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    id: "Capa_1",
    x: 0,
    y: 0,
    viewBox: "0 0 512.032 512.032",
    xmlSpace: "preserve",
    style: {
      enableBackground: "new 0 0 512.032 512.032"
    },
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#f4c534"
    },
    d: "M51.496,418.544l420.64-2.16V12.528c0-6.88-5.648-12.528-12.528-12.528H74.456 C55.368,0,39.928,15.424,39.928,34.528v419.888c0,10.144,4.512,19.184,11.552,25.488v-61.36H51.496z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#3e4347"
    },
    d: "M58.6,421.84h70.736V0h-54.88C55.368,0,39.928,15.424,39.928,34.528v419.888 c0,13.232,7.616,24.608,18.656,30.352V421.84H58.6z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#e9eff4"
    },
    d: "M472.12,416.384c-13.408,25.312-15.744,58.864-2.336,84.16c0,6.88-3.312,5.424-10.192,5.424H74.456 c-19.088,0-24.464-16.416-24.464-35.36v-32.08c0-19.088,5.36-20.592,24.464-20.592h385.152 C466.472,417.952,472.12,409.52,472.12,416.384z"
  }), /*#__PURE__*/React.createElement("ellipse", {
    style: {
      fill: "#fff"
    },
    cx: 233.96,
    cy: 151.296,
    rx: 50.976,
    ry: 63.392
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#3e4347"
    },
    d: "M260.232,164.8c-0.096,14.048-11.84,25.552-26.192,25.488c-14.336-0.064-25.792-11.648-25.696-25.696 c0.096-14.192,11.712-25.68,26.048-25.632C248.744,139.024,260.328,150.608,260.232,164.8z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#fff"
    },
    d: "M249.592,160.992c-1.968,1.968-6.064,1.056-9.216-2.112c-3.168-3.168-4.08-7.248-2.24-9.216 c1.968-1.968,6.192-1.056,9.344,2.112C250.648,154.944,251.576,159.024,249.592,160.992z"
  }), /*#__PURE__*/React.createElement("ellipse", {
    style: {
      fill: "#fff"
    },
    cx: 367.064,
    cy: 151.296,
    rx: 50.976,
    ry: 63.392
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#3e4347"
    },
    d: "M393.336,164.8c-0.096,14.048-11.84,25.552-26.192,25.488c-14.336-0.064-25.792-11.648-25.696-25.696 c0.096-14.192,11.712-25.68,26.048-25.632C381.848,139.024,393.432,150.608,393.336,164.8z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#fff"
    },
    d: "M382.696,160.992c-1.968,1.968-6.064,1.056-9.216-2.112c-3.168-3.168-4.08-7.248-2.24-9.216 c1.968-1.968,6.192-1.056,9.344,2.112C383.752,154.944,384.68,159.024,382.696,160.992z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#3e4347"
    },
    d: "M406.904,261.648c-10.608,38.912-45.504,72.832-96.144,80.4 C249.016,348.8,209.944,316.64,195,293.008c-3.696-6.112,1.12-13.824,8.208-13.664c27.488,0.96,84.256,1.6,160.784-19.776 c11.904-3.376,22.992-6.432,31.68-9.008C402.392,248.624,408.824,254.896,406.904,261.648z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#fff"
    },
    d: "M306.056,297.92c51.024-7.616,75.616-15.808,88.464-47.056c-8.528,2.512-19.12,5.44-30.56,8.688 c-70.176,19.6-123.424,20.672-153.024,19.984C231.672,296.048,263.144,302.672,306.056,297.92z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#e24b4b"
    },
    d: "M310.744,342.032c20.896-3.12,38.912-10.896,53.84-21.488c-9.232-18.544-30.192-25.216-46.704-17.072 c-6.496,3.2-13.488,4.944-20.768,5.424c-20.736,1.168-31.056,14.624-32.528,30.528C278.264,342.576,293.528,343.92,310.744,342.032z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#ffd93b"
    },
    d: "M129.32,427.84h331.344c6.256,0,11.456-5.2,11.456-11.456c0-6.256-5.2-11.456-11.456-11.456H129.32 V427.84z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#ffd93b"
    },
    d: "M460.68,489.088H129.32V512h331.344c6.256,0,11.456-5.2,11.456-11.456 S466.936,489.088,460.68,489.088z"
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#5a5f63"
    },
    d: "M62.776,439.552v38.08c0,6.24,5.28,11.52,11.68,11.52h54.88v22.88h-54.88 c-19.04,0-34.56-15.52-34.56-34.4v-38.24c0-19.04,15.52-34.4,34.56-34.4h54.88v22.88h-54.72 C68.216,427.872,62.776,433.152,62.776,439.552z"
  }));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBook);
export default __webpack_public_path__ + "static/media/book.f4f56b67ad9df9318ef9cebd2af67e7b.svg";
export { ForwardRef as ReactComponent };